<template>
    <div :class="inline ? 'inline-loader-holder' : 'loader-holder'">
        <div class="backdrop" v-if="addBackground"></div>
        <span
            class="far fa-spinner fa-spin fa-3x"
            :class="inline ? 'inline-loader' : 'loader'"
        ></span>
    </div>
</template>
<style scoped>
.backdrop {
    background-color: rgba(255, 255, 255, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.loader-holder {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}
.inline-loader-holder {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 20px 0;
}
.loader,
.inline-loader {
    color: #565252;
    font-size: 40px;
}
.loader {
    position: fixed;
    top: 50%;
    left: 50%;
    margin: -20px 0 0 -20px;
}
</style>
<script>
export default {
    name: "loader",
    props: {
        inline: {
            type: Boolean,
            default: false,
        },
        addBackground: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {};
    },
    methods: {},
};
</script>
